import { MultiLineFilter } from "./MultiLineFilter";

export interface MultiLinePathState {
    storeFiltersWithinSession: boolean;
    currentPage: number;
    instancesPerPage: number;
    rowsHeight?: { [key: string]: number };
    instances: string[];
    filters?: MultiLineFilter[];
    sort?: MultiLineSort;
    loading?: boolean;
    useServerFilter?: boolean;
    filteringResultVersion?: number;
    loadingCounter?: number;
}

export interface MultiLineSort {
    dataPath: string;
    value: SortType;
    dataType: SortDataType;
}

export enum SortEnum {
    Asc = "asc",
    Desc = "desc",
}

export enum DataType {
    Date = "date",
    Number = "number",
    CaseInsensitiveString = "caseInsensitiveString",
}

export type SortType = SortEnum;
export type SortDataType = DataType;
